// TODO: duplicated base colour definitions.
// We could probably user https://amzn.github.io/style-dictionary/ and define everything there.
const LMG_BLUE = '#0054A6';
// const LMG_YELLOW = '#FFDD00'; // never read here
const LMG_RED = '#ED1A3B';
const LMG_BLACK = '#000000';
const LMG_WHITE = '#FFFFFF';
const LMG_LIGHT_GREY = 'lightgrey';
const LMG_PLACEHOLDER_GREY = '#B8B8B8';
const LMG_DISABLED_GREY = '#666666';

const HARRY_BROWN_BLACK = LMG_BLACK;
const HARRY_BROWN_GREY = '#A7A9AB';
const HARRY_BROWN_RED = '#b53641';

const PRIMARY_COLOUR = HARRY_BROWN_BLACK;
const SECONDARY_COLOUR = HARRY_BROWN_RED;
const HIGHLIGHT_COLOUR = LMG_RED;

const theme = {
  colour: {
    general: {
      primary: PRIMARY_COLOUR,
      secondary: SECONDARY_COLOUR,
      highlight: HIGHLIGHT_COLOUR,
    },
    uiControls: {
      primary: PRIMARY_COLOUR,
      secondary: SECONDARY_COLOUR,
    },
    text: {
      heading: {
        primary: PRIMARY_COLOUR,
      },
      content: {
        primary: LMG_BLACK,
      },
      link: {
        primary: LMG_BLUE,
      },
      menu: {
        primary: LMG_WHITE,
      },
      form: {
        textInput: {
          primary: PRIMARY_COLOUR,
          placeholder: LMG_PLACEHOLDER_GREY,
        },
      },
      drawer: {
        primary: LMG_WHITE,
      },
      button: {
        attention: HARRY_BROWN_GREY,
        disabled: LMG_DISABLED_GREY,
      },
      hero: {
        header: LMG_WHITE,
      },
      tabIcons: {
        cart: {
          priceBadge: LMG_WHITE,
        },
      },
      tile: {
        name: LMG_BLACK,
        byline: '#666666',
        price: HARRY_BROWN_RED,
        priceSecondary: '#666666',
        button: LMG_WHITE,
      },
    },
    border: {
      general: {
        primary: PRIMARY_COLOUR,
      },
      appRoot: {
        primary: PRIMARY_COLOUR,
      },
      tile: '#CCCCCC',
    },
    icon: {
      general: {
        primary: PRIMARY_COLOUR,
        secondary: SECONDARY_COLOUR,
      },
      header: {
        primary: LMG_WHITE,
      },
    },
    background: {
      general: {
        primary: PRIMARY_COLOUR,
        contrastOnPrimary: LMG_WHITE,
        // Page background. Not contrastOnPrimary: that is BLACK on Thirsty Camel.
        screen: LMG_WHITE,
        secondary: SECONDARY_COLOUR,
      },
      button: {
        primary: PRIMARY_COLOUR,
        contrastOnPrimary: LMG_WHITE,
        disabled: LMG_LIGHT_GREY,
      },
      hero: {
        header: PRIMARY_COLOUR,
      },
      drawer: PRIMARY_COLOUR,
      feedTile: {
        promotion: HARRY_BROWN_GREY,
      },
      range: {
        tileContainer: PRIMARY_COLOUR,
      },
      tile: {
        surface: LMG_WHITE,
        buttonDisabled: LMG_WHITE,
      },
      memberPriceBadge: '#FFDD00',
    },
    activityIndicator: {
      primary: PRIMARY_COLOUR,
    },
    checkbox: {
      primary: PRIMARY_COLOUR,
    },
    navTab: {
      barBg: LMG_WHITE,
      activeBg: LMG_BLACK,
      activeText: LMG_WHITE,
      inactiveText: LMG_BLACK,
    },
    desktopNavTab: {
      activeBg: LMG_WHITE,
      activeText: LMG_BLACK,
      inactiveText: LMG_WHITE,
    },
    creditCard: {
      background: HARRY_BROWN_BLACK,
      text: LMG_WHITE,
      textMuted: 'rgba(255,255,255,0.7)',
      chip: '#D4AF37',
    },
    // Footer (DIS-1841). SHORTCUT: grey divider; Figma draws BM navy and Universal/Black, which
    // vanishes on the black ground (design error). Upgrade path: design supplies the HB divider.
    footer: {
      divider: '#757575',
      legalText: LMG_BLACK,
    },
    // Header (DIS-1840). SHORTCUT: grey divider and chip from the header prototype (DIS-1859).
    // Upgrade path: design supplies the HB header divider and chip as brand variables.
    header: {
      divider: '#757575',
      cartChip: '#4A4A4A',
      onCartChip: LMG_WHITE,
    },
  },
  size: {
    text: {
      body1: 18,
      body2: 16,
      heading0: 24,
      heading1: 20,
      heading2: 18,
      heading3: 16,
      heading4: 14,
      caption: 14,
    },
    badge: {
      type: 'circle',
      color: '#ED1A3B',
      titleFontSize: 10,
      titleFontSizeLong: 8,
      priceFontSize: 13,
      dollarSignFontSize: 11,
      chevronHeight: 8,
      contentPadding: 3,
      titlePaddingVertical: 2,
      titlePaddingHorizontal: 3,
      pricePaddingVertical: 6,
      textY: 20,
      priceYWithText: 32,
      priceYNoText: 28,
    },
    // Banner geometry — DIS-1181 (web 1300×400) + DIS-1182 (mobile 760×500).
    // Stored as raw width/height; consumers derive aspectRatio = width / height.
    banner: {
      web: {width: 1300, height: 400, maxWidth: 1300, maxHeight: 400},
      mobile: {width: 760, height: 500},
    },
  },
  typography: {
    fontFamily: 'Geologica',
    fontFamilyBold: 'Geologica-Bold',
    weights: {
      light: {fileName: 'Geologica-Light', weight: 300, style: 'normal'},
      regular: {fileName: 'Geologica-Regular', weight: 400, style: 'normal'},
      medium: {fileName: 'Geologica-Medium', weight: 500, style: 'normal'},
      semiBold: {fileName: 'Geologica-SemiBold', weight: 600, style: 'normal'},
      bold: {fileName: 'Geologica-Bold', weight: 700, style: 'normal'},
      extraBold: {fileName: 'Geologica-ExtraBold', weight: 800, style: 'normal'},
    },
  },
};

export default theme;
